const pageTitleInOut = {
    opacity: 0,
    scale: 0.8,
    transformOrigin: 'center',
    duration: 1.5,
};

export default pageTitleInOut;